module.exports = __webpack_public_path__ + "static/icon_item_left.f5107efb.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/icon_item_left.png
// module id = 1045
// module chunks = 2